var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiIconBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#EDEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 16.2886C12.0511 13.5889 16.2113 12.1187 20.5 12.125C24.9635 12.125 29.0625 13.6844 32.2812 16.2886L30.3177 18.7188C27.5406 16.4693 24.0738 15.2444 20.5 15.25C16.7812 15.25 13.3646 16.55 10.6823 18.7188L8.71875 16.2886ZM11.9906 20.3406C14.3975 18.3906 17.4023 17.3287 20.5 17.3334C23.7229 17.3334 26.6833 18.4594 29.0094 20.3396L27.0458 22.7709C25.1943 21.2711 22.8828 20.4545 20.5 20.4584C18.0208 20.4584 15.7437 21.325 13.9542 22.7709L11.9906 20.3396V20.3406ZM15.2635 24.3927C16.7446 23.1926 18.5937 22.539 20.5 22.5417C22.4833 22.5417 24.3052 23.2344 25.7365 24.3917L23.7729 26.8229C22.8471 26.0731 21.6914 25.6648 20.5 25.6667C19.3086 25.6648 18.1529 26.0731 17.2271 26.8229L15.2635 24.3917V24.3927ZM18.5365 28.4448C19.0917 27.9945 19.7851 27.7492 20.5 27.75C21.2437 27.75 21.9271 28.0104 22.4635 28.4438L20.5 30.875L18.5365 28.4438V28.4448Z",
    fill: "#8E8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIconBig);
export default __webpack_public_path__ + "static/media/WifiIconBig.6e643ab26c2f0164b7172f886595f699.svg";
export { ForwardRef as ReactComponent };